import client from "../client";
import * as actions from "modules/common/store/actions";
import * as utility from "utilities/utils";
import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";

const getProfile = async () => {

    const response = await client.get(process.env.REACT_APP_PROFILE);
            
    const languageCode = response?.contactPreferences?.languageCode.toLowerCase();
    const userLanguage = ((languageCode !== undefined && languageCode.length >=2 && languageCode.substring(0, 2) === "fr") ? "fr" : "en");
            
    commonUtilities.setLanguage(userLanguage);
    return utility.getResponse(response);

};


/**
 * To call profile api to get business logo.
 *
 * @returns {response} return a response.
 */
const getBusinessLogo = async () => {

    const url = process.env.REACT_APP_PROFILE + CONFIGURATION.ENDPOINT_GET_BUSINESS_LOGO;
    const response = await client.get(url);
    //response.url = "https://assets.sunwingtravelgroup.com/image/upload/v1747144399/WestJet/BRAND/Logos/WVI/EN/WVI%20Logo_EN.svg";
    return response;

};

export default { getProfile, getBusinessLogo };